import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  isMobile?: boolean;
  isEmpty?: boolean;
  height?: 'full';
  className?: string;
  withTopIndent?: boolean;
}

const Page: FC<IProps> = ({ children, isEmpty, isMobile, height, className }) => {
  return (
    <div
      className={classNames(
        css.page,
        {
          [css.isEmpty]: isEmpty,
          [css.isMobile]: isMobile,
          [css[`page_height_${height}`]]: height,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Page;
